import { WireObject } from 'content-creation-common/models';

import { isNil } from '../../../util/object';

export default class CreativeContentItemWireObject extends WireObject {
  _content = null;
  _height = null;
  _type = null;
  _width = null;

  /**
   * @param {String|null} type - the mimeType
   * @param {String|null} content - the content, either text or asset url
   * @param {Number} width
   * @param {Number} height
   */
  constructor(type = null, content = null, width = null, height = null) {
    super();

    this._type = type;
    this._content = content;
    this._height = height;
    this._width = width;
  }

  /**
   * return {CreativeContentItemWireObject} new CreativeContentItemWireObject without an ID, based on this one.
   */
  copy() {
    return new CreativeContentItemWireObject(
      this.type,
      this.content,
      this.width,
      this.height,
    );
  }

  /**
   * Turn CreativeContentItemWireObject in to JSON Object
   * @returns {{width: *, type: *, content: *, height: *}}
   */
  toJSON() {
    return {
      content: this.content,
      height: this.height,
      type: this.type,
      width: this.width,
    };
  }

  get content() {
    return this._content;
  }

  set content(value) {
    this._content = value;
  }

  get height() {
    return this._height;
  }

  set height(value) {
    this._height = value;
  }

  get type() {
    return this._type;
  }

  set type(value) {
    this._type = value;
  }

  get width() {
    return this._width;
  }

  set width(value) {
    this._width = value;
  }

  /**
   * Test if incoming is instance of CreativeContentItemWireObject
   * @param {any} incoming
   * @returns {boolean}
   */
  static isCreativeContentItemWireObject(incoming) {
    return incoming instanceof CreativeContentItemWireObject;
  }

  /**
   * Turn JSON in to CreativeContentItemWireObject
   * @param {Object} inJSON
   * @returns {CreativeContentItemWireObject}
   */
  static fromJSON(inJSON) {
    if (isNil(inJSON)) {
      throw new Error('CreativeContentItemWireObject.fromJSON inJSON is nil');
    }

    const { content, height, type, width } = inJSON;

    return new CreativeContentItemWireObject(type, content, width, height);
  }
}
